import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <FaqSection />
        <CardsSection />
        <IndexSection />
        <CommentsSection />
        <ContactSection />
        <UpdatesSection />
        <AboutSection />
        <CarouselSection />
        <RankingSection />
        <TopicsSection />
        <MediaSection />
        <AppSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}